import React from 'react';
import { BookingButton } from '../components/BookingButton';
import { TestimonialCard } from '../components/TestimonialCard';
import { Accordion } from '../components/Accordion';
import { testimonials } from '../components/testimonials';
export function ProviSprint() {
  return <div className="w-full min-h-screen bg-[#F1F5F9] overflow-x-hidden pt-20" data-id="element-640">
      {/* SECTION 1 — HERO OFERTĂ */}
      <section className="w-full bg-[#09111F] relative overflow-hidden py-20 md:py-32" data-id="element-641">
        <div className="absolute inset-0 opacity-[0.03] bg-[radial-gradient(#ffffff_1px,transparent_1px)] [background-size:24px_24px]" data-id="element-642"></div>
        <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[800px] h-[800px] bg-[#1D4ED8] opacity-10 blur-[150px] rounded-full pointer-events-none" data-id="element-643"></div>
        <div className="max-w-[1200px] mx-auto px-5 md:px-12 relative z-10" data-id="element-644">
          <div className="grid md:grid-cols-2 gap-12 items-center" data-id="element-645">
            <div data-id="element-646">
              <h1 className="font-['Montserrat'] text-[clamp(40px,5vw,64px)] font-extrabold text-white leading-[1.1] mb-6 text-left" data-id="element-647">
                ProVi Sprint
              </h1>
              <p className="font-['Inter'] text-[20px] md:text-[24px] font-light text-[rgba(255,255,255,0.8)] leading-[1.6] mb-10 text-left" data-id="element-648">
                12 săptămâni. 8 componente. Implementare reală alături de
                antreprenori ca tine.
              </p>
              <div className="text-left" data-id="element-649">
                <BookingButton text="Aplică pentru ProVi Sprint!" href="#oferta" className="px-10 py-5 text-[16px] inline-block mb-3" data-id="element-650" />
                <p className="font-['Inter'] text-[13px] text-white opacity-80" data-id="element-651">
                  Locurile sunt limitate pentru a asigura calitatea
                  implementării.
                </p>
              </div>
            </div>
            <div className="relative hidden md:block" data-id="element-652">
              <div className="absolute inset-0 bg-[#1D4ED8] opacity-20 blur-[60px] rounded-full" data-id="element-653"></div>
              <img src="https://images.unsplash.com/photo-1552664730-d307ca884978?q=80&w=2070&auto=format&fit=crop" alt="ProVi Sprint" className="relative z-10 w-full rounded-2xl border-2 border-[rgba(255,255,255,0.1)] shadow-2xl object-cover aspect-[4/3]" data-id="element-654" />
            </div>
          </div>
        </div>
      </section>

      {/* SECTION 2 — DESCRIERE */}
      <section className="w-full bg-white py-16 md:py-24" data-id="element-655">
        <div className="max-w-[800px] mx-auto px-5 md:px-12" data-id="element-656">
          <div className="bg-[#F1F5F9] rounded-3xl p-8 md:p-12 border border-[rgba(0,0,0,0.04)]" data-id="element-657">
            <h2 className="font-['Montserrat'] text-[32px] md:text-[40px] font-bold text-[#09111F] mb-8 text-center" data-id="element-658">
              Ai înțeles ce trebuie schimbat. Acum ai nevoie de un cadru în care
              să o faci.
            </h2>
            <div className="space-y-6 font-['Inter'] text-[19px] font-light text-[#4B5563] leading-[1.8]" data-id="element-659">
              <p data-id="element-660">
                Ai citit cărțile. Ai fost la workshop-uri. Poate ai și
                toolkit-ul. Știi că afacerea ta are nevoie de viziune, de roluri
                clare, de KPI-uri, de ședințe care produc ceva. Dar între a ști
                și a face este un gol imens, pentru că singur, fără un cadru,
                fără un ritm și fără cineva care te ține responsabil, lucrurile
                nu se implementează. Rămân pe lista de "ar trebui".
              </p>
              <p data-id="element-661">
                Cu fiecare săptămână în care nu implementezi, echipa ta își
                consolidează obiceiurile vechi. Improvizația devine normală.
                Plafonul devine confortabil. Și distanța dintre unde ești și
                unde ai putea fi crește fără să o simți.
              </p>
              <p className="font-medium text-[#09111F] p-6 bg-white rounded-2xl border-l-4 border-[#1D4ED8] shadow-sm" data-id="element-662">
                ProVi Sprint este programul de grup de 12 săptămâni în care
                implementezi ProVi System alături de alți antreprenori care trec
                prin provocări similare cu ale tale. Sesiuni live cu Valer în
                fiecare săptămână, exerciții practice aplicate pe afacerea ta
                reală, toate instrumentele ProVi și o comunitate care te ține pe
                drumul cel bun. Nu înveți teorie. Implementezi.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* SECTION 3B — CE FACEM ÎN CELE 12 SĂPTĂMÂNI */}
      <section className="w-full bg-[#F1F5F9] py-16 md:py-24" data-id="element-663">
        <div className="max-w-[1000px] mx-auto px-5 md:px-12" data-id="element-664">
          <div className="text-center mb-16" data-id="element-665">
            <h2 className="font-['Montserrat'] text-[32px] md:text-[40px] font-bold text-[#09111F] mb-4" data-id="element-666">
              Ce construiești concret în cele 12 săptămâni de ProVi Sprint
            </h2>
          </div>
          <div className="grid md:grid-cols-2 gap-6" data-id="element-667">
            {[{
            phase: 'Săptămânile 1-2: Mentalitate și Viziune',
            items: ["Clarifici ce fel de antreprenor vrei să fii și treci de la 'totul depinde de mine' la 'construiesc un sistem care merge și fără mine'", 'Construiești viziunea companiei pe 3 ani și o traduci în obiective anuale concrete pe care echipa ta le înțelege', 'Definești cultura organizațională: valorile după care se iau deciziile în compania ta în fiecare zi']
          }, {
            phase: 'Săptămânile 3-4: Oamenii și Rolurile',
            items: ['Construiești organigrama funcțională a companiei tale și clarifici cine răspunde de ce și față de cine', 'Completezi fișele de rol pentru fiecare om din echipa de lideri cu responsabilități clare și indicatori de performanță', 'Folosești Radarul Oamenilor Potriviți ca să identifici cine este în rolul corect și unde ai nepotriviri care te costă']
          }, {
            phase: 'Săptămânile 5-6: Numerele care Contează',
            items: ['Alegi 5 până la 7 indicatori cheie care îți arată săptămânal dacă afacerea merge în direcția bună', 'Configurezi Tabela de Marcaj și înveți cum să o completezi în 10 minute și cum să o citești corect', 'Înveți să conduci pe cifre reale în loc să conduci pe impresii sau pe ce simți tu că merge și ce nu']
          }, {
            phase: 'Săptămânile 7-8: Procesele și Problemele',
            items: ['Documentezi cele 3 până la 5 procese critice din companie în SOP-uri simple pe care orice om nou le poate urma', 'Implementezi sistemul de identificare și rezolvare a problemelor la cauză, nu la simptom', 'Construiești lista de probleme și înveți cum să o folosești în ședința săptămânală fără să se transforme în sesiune de plângeri']
          }, {
            phase: 'Săptămânile 9-10: Progresul și Ritmul',
            items: ['Instalezi ritmul de ședințe săptămânale Puls 10 cu format fix care se termină cu decizii și acțiuni asumate', 'Construiești structura sesiunilor trimestriale de planificare pe care le poți conduce singur de acum înainte', 'Înveți cum să verifici progresul echipei fără să devii polițist și fără să fii prezent în fiecare zi']
          }, {
            phase: 'Săptămânile 11-12: Cash și Planul de 90 de Zile',
            items: ['Pui cashflow-ul sub control cu instrumentul de urmărire financiară simplă care îți arată starea reală în 15 minute', 'Construiești planul complet pentru următorul trimestru cu obiectiv, priorități, responsabili și termene pe o singură pagină', 'Faci retrospectiva celor 12 săptămâni și identifici ce menții, ce ajustezi și care este următorul pas pentru afacerea ta']
          }].map((phase, index) => <div key={index} className="bg-white p-8 rounded-2xl shadow-[0_4px_20px_rgba(0,0,0,0.04)] border border-[rgba(0,0,0,0.04)]" data-id="element-668">
                <h3 className="font-['Montserrat'] text-[18px] font-bold text-[#09111F] mb-4 text-[#1D4ED8]" data-id="element-669">
                  {phase.phase}
                </h3>
                <ul className="space-y-3" data-id="element-670">
                  {phase.items.map((item, i) => <li key={i} className="flex items-start gap-3" data-id="element-671">
                      <div className="w-2 h-2 rounded-full bg-[#1D4ED8] mt-2 flex-shrink-0" data-id="element-672"></div>
                      <span className="font-['Inter'] text-[15px] text-[#4B5563] leading-[1.6]" data-id="element-673">
                        {item}
                      </span>
                    </li>)}
                </ul>
              </div>)}
          </div>
        </div>
      </section>

      {/* SECTION 4 — BENEFICII */}
      <section className="w-full bg-white py-16 md:py-24" data-id="element-674">
        <div className="max-w-[1000px] mx-auto px-5 md:px-12" data-id="element-675">
          <h2 className="font-['Montserrat'] text-[32px] md:text-[40px] font-bold text-[#09111F] mb-12 text-center" data-id="element-676">
            Ce obții concret după cele 12 săptămâni de ProVi Sprint
          </h2>
          <div className="flex flex-col gap-6" data-id="element-677">
            {[{
            title: 'Toate cele 8 componente ProVi implementate',
            desc: 'Nu doar înțelese. Implementate. Cu instrumente completate, roluri clarificate, KPI-uri setate și ritm de ședințe construit.'
          }, {
            title: '12 sesiuni live cu Valer Dura',
            desc: 'O sesiune pe săptămână în care lucrezi direct pe afacerea ta, nu pe exemple teoretice. Valer facilitează, provoacă și te ține responsabil.'
          }, {
            title: 'Toate instrumentele ProVi System incluse',
            desc: 'Organizatorul Viziune și Strategie, Tabela de Marcaj, Lista de Probleme, Modelul Puls 10, Planul Trimestrial, Radarul Oamenilor, Urmărire Cash, Fișe de Rol, SOP Builder. Totul.'
          }, {
            title: 'Comunitate de antreprenori',
            desc: 'Nu ești singur în proces. Lucrezi alături de oameni care au aceleași probleme și te motivează prin progresul lor real.'
          }, {
            title: 'Responsabilizare săptămânală',
            desc: "Fiecare săptămână începe cu review-ul a ce ai implementat și ce nu. Nu mai amâni. Nu mai 'o faci când ai timp'. Ritmul programului te ține pe drum."
          }, {
            title: 'Acces la toate înregistrările sesiunilor',
            desc: 'Dacă ratezi o sesiune, o poți revedea. Toate materialele rămân accesibile pe toată durata programului și 90 de zile după finalizare.'
          }, {
            title: 'Plan complet de 90 de zile',
            desc: 'La finalul celor 12 săptămâni ai un plan trimestrial complet pe o singură pagină, cu tot ce ai nevoie ca să continui singur.'
          }].map((benefit, i) => <div key={i} className="bg-[#F1F5F9] rounded-2xl p-6 md:p-8 border border-[rgba(0,0,0,0.04)] flex flex-col md:flex-row gap-6 items-start" data-id="element-678">
                <div className="w-12 h-12 bg-white rounded-xl flex items-center justify-center flex-shrink-0 text-[#1D4ED8] shadow-sm" data-id="element-679">
                  <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24" data-id="element-680">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 13l4 4L19 7" data-id="element-681"></path>
                  </svg>
                </div>
                <div data-id="element-682">
                  <h3 className="font-['Montserrat'] text-[20px] font-bold text-[#09111F] mb-3" data-id="element-683">
                    {benefit.title}
                  </h3>
                  <p className="font-['Inter'] text-[16px] text-[#4B5563] leading-[1.6]" data-id="element-684">
                    {benefit.desc}
                  </p>
                </div>
              </div>)}
          </div>
        </div>
      </section>

      {/* SECTION 5 — CINE SUNT EU */}
      <section className="w-full bg-[#0A1628] py-16 md:py-24 text-white" data-id="element-685">
        <div className="max-w-[1200px] mx-auto px-5 md:px-12" data-id="element-686">
          <div className="grid md:grid-cols-2 gap-12 items-center" data-id="element-687">
            <div className="relative" data-id="element-688">
              <div className="absolute inset-0 bg-[#1D4ED8] opacity-20 blur-[60px] rounded-full" data-id="element-689"></div>
              <img src="https://cdn.magicpatterns.com/uploads/fWFHPTDBhfM1RiRRjS7QNx/Valer_1.jpg" alt="Valer Dura" className="relative z-10 w-full max-w-[450px] mx-auto rounded-2xl border-2 border-[rgba(255,255,255,0.1)] shadow-2xl object-cover" data-id="element-690" />
            </div>
            <div data-id="element-691">
              <h2 className="font-['Montserrat'] text-[32px] md:text-[40px] font-bold mb-8 text-left" data-id="element-692">
                Cine conduce ProVi Sprint și de ce contează asta
              </h2>
              <div className="space-y-6 font-['Inter'] text-[19px] font-light text-[rgba(255,255,255,0.8)] leading-[1.8] text-left" data-id="element-693">
                <p data-id="element-694">
                  Sunt Valer Dura. Am construit, eficientizat și vândut
                  propriile afaceri cu cifre de milioane de euro. De 12 ani
                  lucrez direct cu antreprenori și echipe de lideri din companii
                  românești.
                </p>
                <p data-id="element-695">
                  ProVi Sprint nu este un curs pe care îl urmărești pasiv. Este
                  un program de implementare ghidată în care eu facilitez
                  fiecare sesiune, lucrez pe afacerea fiecărui participant și mă
                  asigur că la finalul celor 12 săptămâni fiecare om din grup
                  are ceva concret implementat, nu doar notițe.
                </p>
                <p data-id="element-696">
                  Am construit acest program pentru antreprenorii care au nevoie
                  de mai mult decât un toolkit și mai puțin decât o implementare
                  completă de 12 luni. ProVi Sprint este pasul din mijloc:
                  suficient de structurat ca să producă rezultate reale,
                  suficient de accesibil ca să nu fie o decizie grea.
                </p>
                <p className="font-medium text-white border-l-4 border-[#3B82F6] pl-6 py-2" data-id="element-697">
                  Nu predau teorie. Construim împreună. Fiecare sesiune se
                  termină cu ceva concret pe care îl aplici în afacerea ta chiar
                  în acea săptămână.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* SECTION 6 — PENTRU CINE ESTE / NU ESTE */}
      <section className="w-full bg-white py-16 md:py-24" data-id="element-698">
        <div className="max-w-[1000px] mx-auto px-5 md:px-12" data-id="element-699">
          <div className="grid md:grid-cols-2 gap-8" data-id="element-700">
            <div className="bg-[#EFF6FF] rounded-3xl p-8 border border-[rgba(59,130,246,0.2)]" data-id="element-701">
              <h3 className="font-['Montserrat'] text-[24px] font-bold text-[#09111F] mb-6 flex items-center gap-3" data-id="element-702">
                <div className="w-8 h-8 rounded-full bg-[#1D4ED8] text-white flex items-center justify-center" data-id="element-703">
                  <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24" data-id="element-704">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 13l4 4L19 7" data-id="element-705"></path>
                  </svg>
                </div>
                ProVi Sprint este pentru tine dacă:
              </h3>
              <ul className="space-y-4" data-id="element-706">
                {['Ești antreprenor cu minimum 3 angajați și simți că ai nevoie de structură, nu de mai mult efort', 'Ai participat la workshop sau ai ProVi Toolkit și vrei să treci de la instrumente la implementare reală', 'Vrei să lucrezi alături de alți antreprenori care trec prin provocări similare, nu singur'].map((item, i) => <li key={i} className="flex items-start gap-3" data-id="element-707">
                    <div className="w-2 h-2 rounded-full bg-[#1D4ED8] mt-2 flex-shrink-0" data-id="element-708"></div>
                    <span className="font-['Inter'] text-[17px] text-[#4B5563] leading-[1.6]" data-id="element-709">
                      {item}
                    </span>
                  </li>)}
              </ul>
            </div>
            <div className="bg-[#FEF2F2] rounded-3xl p-8 border border-[rgba(239,68,68,0.2)]" data-id="element-710">
              <h3 className="font-['Montserrat'] text-[24px] font-bold text-[#09111F] mb-6 flex items-center gap-3" data-id="element-711">
                <div className="w-8 h-8 rounded-full bg-[#EF4444] text-white flex items-center justify-center" data-id="element-712">
                  <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24" data-id="element-713">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M6 18L18 6M6 6l12 12" data-id="element-714"></path>
                  </svg>
                </div>
                ProVi Sprint nu este pentru tine dacă:
              </h3>
              <ul className="space-y-4" data-id="element-715">
                {['Ai nevoie de lucru individual intensiv 1 la 1 cu Valer direct în compania ta, pentru asta există Implementarea de 12 luni', 'Nu ești dispus să faci exercițiile săptămânale și să implementezi în afacerea ta între sesiuni', 'Cauți doar informație, nu implementare, pentru asta este suficient ProVi Toolkit la 97 €'].map((item, i) => <li key={i} className="flex items-start gap-3" data-id="element-716">
                    <div className="w-2 h-2 rounded-full bg-[#EF4444] mt-2 flex-shrink-0" data-id="element-717"></div>
                    <span className="font-['Inter'] text-[17px] text-[#4B5563] leading-[1.6]" data-id="element-718">
                      {item}
                    </span>
                  </li>)}
              </ul>
            </div>
          </div>
        </div>
      </section>

      {/* SECTION 7 — RECAPITULARE INVESTIȚIE */}
      <section className="w-full bg-[#F1F5F9] py-16 md:py-24" data-id="element-719">
        <div className="max-w-[800px] mx-auto px-5 md:px-12" data-id="element-720">
          <div id="oferta" className="bg-white rounded-3xl p-8 md:p-12 border-2 border-[#1D4ED8] shadow-[0_20px_40px_rgba(29,78,216,0.08)] relative scroll-mt-24" data-id="element-721">
            <div className="absolute -top-4 inset-x-0 flex justify-center" data-id="element-722">
              <span className="bg-[#1D4ED8] text-white font-['Montserrat'] text-[12px] font-bold tracking-[0.15em] uppercase px-6 py-2 rounded-full shadow-md" data-id="element-723">
                RECAPITULARE
              </span>
            </div>
            <h2 className="font-['Montserrat'] text-[28px] md:text-[36px] font-bold text-[#09111F] mb-8 text-center mt-4" data-id="element-724">
              Hai să recapitulăm ce primești în ProVi Sprint
            </h2>

            <div className="flex flex-col gap-10" data-id="element-725">
              <div data-id="element-726">
                <h3 className="font-['Montserrat'] text-[20px] font-bold text-[#1D4ED8] mb-6 border-b pb-2" data-id="element-727">
                  Ce este inclus:
                </h3>
                <ul className="space-y-4" data-id="element-728">
                  {['12 sesiuni live de grup cu Valer Dura, câte una pe săptămână (Valoare: 2.400 €)', 'Toate instrumentele complete ProVi System: 9 template-uri cu ghiduri de completare (Valoare: 295 €)', 'Comunitate privată de antreprenori pe durata programului (Valoare: 297 €)', 'Acces la toate înregistrările sesiunilor plus 90 de zile după finalizare', 'Chestionar de diagnostic ProVi completat și analizat înainte de prima sesiune'].map((item, i) => <li key={i} className="flex items-start gap-3" data-id="element-729">
                      <svg className="w-5 h-5 text-[#1D4ED8] flex-shrink-0 mt-0.5" fill="none" stroke="currentColor" viewBox="0 0 24 24" data-id="element-730">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 13l4 4L19 7" data-id="element-731"></path>
                      </svg>
                      <span className="font-['Inter'] text-[16px] text-[#4B5563] leading-[1.6]" data-id="element-732">
                        {item}
                      </span>
                    </li>)}
                </ul>
              </div>
              <div data-id="element-733">
                <div className="bg-[#F1F5F9] rounded-xl p-8 text-center border border-[rgba(0,0,0,0.05)]" data-id="element-734">
                  <p className="font-['Inter'] text-[16px] text-[#6B7280] line-through mb-1" data-id="element-735">
                    Valoare totală reală: 2.992 €
                  </p>
                  <p className="font-['Montserrat'] text-[48px] font-bold text-[#09111F] mb-2" data-id="element-736">
                    1.500 €
                  </p>
                  <p className="font-['Inter'] text-[16px] text-[#4B5563] mb-6" data-id="element-737">
                    Plată integrală: 1.500 € / 2 rate: 2 x 800 €
                  </p>
                  <div className="bg-[#FEF2F2] rounded-lg p-4 border border-[rgba(239,68,68,0.2)] inline-block mx-auto mb-4" data-id="element-738">
                    <p className="font-['Inter'] text-[14px] text-[#EF4444] font-medium" data-id="element-739">
                      Maximum [LIPSĂ] participanți per ediție.
                    </p>
                  </div>
                  <p className="font-['Inter'] text-[14px] text-[#4B5563]" data-id="element-740">
                    Data următoarei ediții: [LIPSĂ]
                  </p>
                </div>
              </div>
            </div>

            <div className="mt-12 text-center" data-id="element-741">
              <BookingButton text="Aplică pentru ProVi Sprint — 1.500 €" href="/contact" className="px-10 py-5 text-[16px] w-full sm:w-auto" data-id="element-742" />
            </div>
          </div>
        </div>
      </section>

      {/* SECTION 8 — TESTIMONIALE */}
      <section className="w-full bg-white py-16 md:py-24" data-id="element-743">
        <div className="max-w-[1200px] mx-auto px-5 md:px-12" data-id="element-744">
          <div className="text-center mb-16" data-id="element-745">
            <h2 className="font-['Montserrat'] text-[32px] md:text-[40px] font-bold text-[#09111F]" data-id="element-746">
              Ce spun antreprenorii care au trecut prin ProVi Sprint
            </h2>
          </div>
          <div className="grid md:grid-cols-3 gap-8" data-id="element-747">
            {testimonials.map((t, i) => <TestimonialCard key={i} {...t} data-id="element-748" />)}
          </div>
        </div>
      </section>

      {/* SECTION 9 — ÎNTREBĂRI FRECVENTE */}
      <section className="w-full bg-[#F1F5F9] py-16 md:py-24" data-id="element-749">
        <div className="max-w-[1000px] mx-auto px-5 md:px-12" data-id="element-750">
          <div className="text-center mb-16" data-id="element-751">
            <h2 className="font-['Montserrat'] text-[32px] md:text-[40px] font-bold text-[#09111F]" data-id="element-752">
              Întrebări Frecvente
            </h2>
          </div>
          <Accordion items={[{
          question: 'Câți oameni sunt în grup?',
          answer: 'Grupul este limitat la [LIPSĂ] participanți pentru a permite lucrul individual pe afacerea fiecăruia. Nu este un webinar cu 200 de oameni. Este un program de lucru în care Valer cunoaște fiecare participant și fiecare afacere.'
        }, {
          question: 'Ce se întâmplă dacă ratez o sesiune?',
          answer: 'Primești înregistrarea completă a sesiunii și materialele aferente. Poți face exercițiile pe cont propriu și le aduci la review în sesiunea următoare. Nu se pierde nimic, dar prezența live dă rezultate mult mai bune.'
        }, {
          question: 'Pot participa împreună cu un partener de business sau un lider de departament?',
          answer: 'Da. Dacă participi cu cineva din echipă, implementarea merge mai rapid pentru că lucrați în tandem. Fiecare persoană plătește separat locul în program.'
        }, {
          question: 'Cât timp trebuie să aloc pe săptămână?',
          answer: 'Sesiunea live durează 90 minute până la 2 ore. În plus, ai nevoie de 1 până la 2 ore pe săptămână pentru exercițiile de implementare în afacerea ta. Total: 3 până la 4 ore pe săptămână timp de 12 săptămâni.'
        }, {
          question: 'Ce se întâmplă după cele 12 săptămâni?',
          answer: 'Ai 3 opțiuni. Poți continua singur cu planul trimestrial construit în program. Poți accesa sesiunea bonus de planificare la 90 de zile. Sau poți trece la implementarea completă ProVi System de 12 luni cu un discount de 1.500 € dedus din investiție.'
        }, {
          question: 'Vor fi alți antreprenori din domeniul meu în grup?',
          answer: 'Nu. Grupul este alcătuit din antreprenori din domenii diferite, necompetitive. Provocările de sistem sunt aceleași indiferent de industrie: viziune neclară, roluri confuze, cifre nemonitorizate, ritm absent. Diversitatea de domenii face ca perspectivele din grup să fie mai valoroase.'
        }, {
          question: 'Cum e diferit față de ProVi Toolkit sau față de workshop?',
          answer: 'ProVi Toolkit îți dă instrumentele. Workshop-ul îți dă claritate și un plan pe 90 de zile într-o singură sesiune. ProVi Sprint îți dă implementare ghidată timp de 12 săptămâni pe toate cele 8 componente, cu responsabilizare săptămânală și comunitate. Diferența este între a avea instrumentele și a le folosi efectiv cu cineva care te ține pe drum.'
        }]} data-id="element-753" />
        </div>
      </section>
    </div>;
}